export enum ModalTypes {
  mainform = 'mainform',
  coapplicant = 'coapplicant', // add coapplicant (w/o form)
  exceptionFlow = 'exceptionFlow',
  loanSelect = 'loanSelect',
  offer = 'offer',
  straightDecline = 'straightDecline'
}
